import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import Layout from "../components/Layout";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") setStatus("paid");
        else if (data.status === "expired") setStatus("expired");
        else if (attempts < 6) {
          attempts++;
          setTimeout(poll, 2000);
        } else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <Layout>
      <div className="max-w-xl mx-auto tray p-10 text-center" data-testid="payment-success">
        {status === "checking" && (
          <>
            <Loader2 className="w-12 h-12 text-amber-500 animate-spin mx-auto mb-4" />
            <h1 className="font-display text-3xl mb-2">Verifying Payment</h1>
            <p className="text-text-secondary">Polling Stripe for confirmation...</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-4" />
            <h1 className="font-display text-4xl mb-2">Bond Posted</h1>
            <p className="text-text-secondary mb-6">
              ${info?.amount?.toLocaleString()} {info?.currency?.toUpperCase()} confirmed.
            </p>
            <button onClick={() => navigate("/dashboard")} data-testid="back-to-desk" className="btn-tactile btn-amber">
              Return to Desk
            </button>
          </>
        )}
        {(status === "expired" || status === "timeout" || status === "error") && (
          <>
            <XCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
            <h1 className="font-display text-3xl mb-2">Payment Incomplete</h1>
            <p className="text-text-secondary mb-6">Please retry or contact support.</p>
            <button onClick={() => navigate("/bid-bond")} className="btn-tactile">Try Again</button>
          </>
        )}
      </div>
    </Layout>
  );
}
